function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BubbleMenu as BaseBubbleMenu } from "@tiptap/react";
import { isTextSelection } from "@tiptap/core";
import { themeGet, media } from "sprout-ui-theme";
import { useCallback, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { CodeOutlined, FormatBoldOutlined, FormatHeader1, FormatHeader2, FormatItalicOutlined, FormatListNumberedOutlined, FormatQuote, FormatStrikethroughOutlined, FormatUnderlinedOutlined, ListOutlined } from "sprout-ui-icons";
import { Button } from "../../Button";
import BaseDivider from "../../Divider";
const Divider = styled(BaseDivider)`
  display: inline-flex;
`;
const SelectionMenuItemButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${themeGet("colors.white.100")};
  width: 45px;
  height: 45px;
  flex-shrink: 0;

  :not(:disabled) {
    ${media.target("pointer")} {
      :hover {
        background: ${themeGet("colors.grey.800")};
      }
    }

    :active {
      background: ${themeGet("colors.grey.700")};
    }
  }

  ${({ $isActive  })=>$isActive && css`
      color: ${themeGet("colors.blue.40")};
    `}
`;
const SelectionMenuItem = (props)=>{
    const { icon , onClick , isActive  } = props;
    return /*#__PURE__*/ _jsx(SelectionMenuItemButton, {
        onClick: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onClick();
        },
        $isActive: isActive,
        children: icon
    });
};
const BubbleMenu = styled(BaseBubbleMenu)`
  display: flex;
  align-items: center;
  background: ${themeGet("colors.primary")};
  border-radius: 8px;
  overflow: hidden;
`;
const tippyOptions = {
    maxWidth: "unset",
    trigger: "manual"
};
const SelectionMenu = (props)=>{
    const { editor  } = props;
    const supportHeadings = !!editor.commands.toggleHeading;
    const supportList = !!editor.commands.toggleBulletList && !!editor.commands.toggleOrderedList;
    const supportBlockquote = !!editor.commands.toggleBlockquote;
    const supportCodeBlock = !!editor.commands.toggleCodeBlock;
    const coreMenuItems = [
        {
            key: "Bold",
            icon: /*#__PURE__*/ _jsx(FormatBoldOutlined, {}),
            isActive: editor.isActive("bold"),
            onClick: ()=>{
                editor.chain().focus().toggleBold().run();
            }
        },
        {
            key: "Italic",
            icon: /*#__PURE__*/ _jsx(FormatItalicOutlined, {}),
            isActive: editor.isActive("italic"),
            onClick: ()=>{
                editor.chain().focus().toggleItalic().run();
            }
        },
        {
            key: "Underline",
            icon: /*#__PURE__*/ _jsx(FormatUnderlinedOutlined, {}),
            isActive: editor.isActive("underline"),
            onClick: ()=>{
                editor.chain().focus().toggleUnderline().run();
            }
        },
        {
            key: "Strikethrough",
            icon: /*#__PURE__*/ _jsx(FormatStrikethroughOutlined, {}),
            isActive: editor.isActive("strike"),
            onClick: ()=>{
                editor.chain().focus().toggleStrike().run();
            }
        },
        {
            key: "Code",
            icon: /*#__PURE__*/ _jsx(CodeOutlined, {}),
            isActive: editor.isActive("code"),
            onClick: ()=>{
                editor.chain().focus().toggleCode().run();
            }
        }, 
    ];
    const miscMenuItems = [];
    if (supportHeadings) miscMenuItems.push({
        key: "Heading-1",
        icon: /*#__PURE__*/ _jsx(FormatHeader1, {}),
        isActive: editor.isActive("heading", {
            level: 1
        }),
        onClick: ()=>{
            editor.chain().focus().toggleHeading({
                level: 1
            }).run();
        }
    }, {
        key: "Heading-2",
        icon: /*#__PURE__*/ _jsx(FormatHeader2, {}),
        isActive: editor.isActive("heading", {
            level: 2
        }),
        onClick: ()=>{
            editor.chain().focus().toggleHeading({
                level: 2
            }).run();
        }
    });
    if (supportList) miscMenuItems.push({
        key: "BulletList",
        icon: /*#__PURE__*/ _jsx(ListOutlined, {}),
        isActive: editor.isActive("bulletList"),
        onClick: ()=>{
            editor.chain().focus().toggleBulletList().run();
        }
    }, {
        key: "OrderedList",
        icon: /*#__PURE__*/ _jsx(FormatListNumberedOutlined, {}),
        isActive: editor.isActive("orderedList"),
        onClick: ()=>{
            editor.chain().focus().toggleOrderedList().run();
        }
    });
    if (supportBlockquote) miscMenuItems.push({
        key: "Blockquote",
        icon: /*#__PURE__*/ _jsx(FormatQuote, {}),
        isActive: editor.isActive("blockquote"),
        onClick: ()=>{
            editor.chain().focus().toggleBlockquote().run();
        }
    });
    if (supportCodeBlock) miscMenuItems.push({
        key: "Codeblock",
        icon: /*#__PURE__*/ _jsx(CodeOutlined, {}),
        isActive: editor.isActive("codeBlock"),
        onClick: ()=>{
            editor.chain().focus().toggleCodeBlock().run();
        }
    });
    /**
   * Extended from
   * https://github.com/ueberdosis/tiptap/blob/ab4a0e2507b4b92c46d293a0bb06bb00a04af6e0/packages/extension-bubble-menu/src/bubble-menu-plugin.ts#L55-L66
   */ const shouldShow = useCallback((cbProps)=>{
        const { view , state , from , to  } = cbProps;
        const isImageSelected = cbProps.editor.isActive("image");
        const isReadOnly = !view.editable;
        if (isImageSelected || isReadOnly) return false;
        if (!state.selection.empty) return true;
        const { doc , selection  } = state;
        const { empty  } = selection;
        const isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(state.selection);
        if (!view.hasFocus() || empty || isEmptyTextBlock) return false;
        return true;
    }, []);
    /**
   * Potential fix for `SelectionMenu` jitter on mount
   * https://sprout.io/leaf/38388
   */ const [mount, setMount] = useState(false);
    useEffect(()=>{
        const timer = setTimeout(()=>{
            setMount(true);
        }, 10);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ _jsx(BubbleMenu, {
        editor: editor,
        tippyOptions: tippyOptions,
        shouldShow: shouldShow,
        children: mount && /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                coreMenuItems.map((selectionMenuItem)=>{
                    const { key  } = selectionMenuItem, rest = _objectWithoutProperties(selectionMenuItem, [
                        "key"
                    ]);
                    return /*#__PURE__*/ _jsx(SelectionMenuItem, _objectSpread({}, rest), key);
                }),
                miscMenuItems.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Divider, {
                            height: "24px",
                            width: "1px",
                            mx: 1,
                            bg: "white.40"
                        }),
                        miscMenuItems.map((selectionMenuItem)=>{
                            const { key  } = selectionMenuItem, rest = _objectWithoutProperties(selectionMenuItem, [
                                "key"
                            ]);
                            return /*#__PURE__*/ _jsx(SelectionMenuItem, _objectSpread({}, rest), key);
                        })
                    ]
                })
            ]
        })
    });
};
export default SelectionMenu;
